import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import { memo, useCallback } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { useBudgets } from '../../hooks/useBudgets';
import { useToggleXeroBudgetsSyncMutation } from '../../hooks/useToggleXeroBudgetsSyncMutation';
import { syncAllBudgetsPageState } from '../../states';
import PullBudgetButton from '../PullBudgetButton/PullBudgetButton';

const PullXeroBudgetButton = memo(() => {
    const company = useCompanyBasedOnUrl();
    const companyId = company.id;
    const syncAllBudgetsState = useAtomValue(syncAllBudgetsPageState);

    const { isInitialLoading: isLoadingBudgets } = useBudgets();
    const { toggleXeroBudgetsSync, isLoadingToggleXeroBudgetsSync } = useToggleXeroBudgetsSyncMutation(companyId);

    const enableSync = useCallback(() => {
        toggleXeroBudgetsSync(
            {
                companyId,
                isEnabled: true,
            },
            domain.IntegrationType.Xero
        );
    }, [companyId, toggleXeroBudgetsSync]);

    return (
        <PullBudgetButton
            disabled={isLoadingBudgets || syncAllBudgetsState || isLoadingToggleXeroBudgetsSync || company.isReadonly}
            onClick={enableSync}
            integrationType={domain.IntegrationType.Xero}
        />
    );
});

export default PullXeroBudgetButton;
